module.exports = __webpack_public_path__ + "img/arrow_black_long_v2.810f5712.svg";